import { render, staticRenderFns } from "./FormBuilderSectionFieldsDrawer.vue?vue&type=template&id=08a7ec95&"
import script from "./FormBuilderSectionFieldsDrawer.vue?vue&type=script&lang=ts&"
export * from "./FormBuilderSectionFieldsDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports